import { createSelector } from '@reduxjs/toolkit'

import type { Gift } from '@/entities/cart'

import { RootState } from '../../../store/rootReducer'

import type { ProductGiftConfig } from './model/cart-slice'

export const selectCartState = (state: RootState) => (state as any).cart

// НОВАЯ АРХИТЕКТУРА: селектор для изолированной конфигурации подарков
export const selectProductGiftConfig = (productId: number) =>
	createSelector(selectCartState, cart => cart?.productGiftsConfig?.[productId] as ProductGiftConfig | undefined)

export const selectAllGiftsByProduct = (productId: number) =>
	createSelector(selectCartState, cart => (cart?.allGiftsByProduct?.[productId] || []) as Gift[])

export const selectExcludedAllFlagByProduct = (productId: number) =>
	createSelector(selectCartState, cart => Boolean(cart?.excludedAutoGiftsByProduct?.[productId]))

export const selectExcludedIdsByProduct = (productId: number) =>
	createSelector(selectCartState, cart => (cart?.excludedAutoGiftIdsByProduct?.[productId] || []) as number[])

// New: packages support
export const selectAllGiftPackagesByProduct = (productId: number) =>
	createSelector(selectCartState, cart => (cart?.allGiftPackagesByProduct?.[productId] || []) as Gift[][])

export const selectSelectedAllPackageIndexByProduct = (productId: number) =>
	createSelector(selectCartState, cart => cart?.selectedAllPackageIndexByProduct?.[productId] as number | undefined)
